/*
    TitleRoom TITLE The Anywhere Machine
    Pic opening
    Hints 2532 2534 2536 2538
    Welcome to "Uncle Julius and the Anywhere Machine"! Click "BEGIN THE ADVENTURE" when you're ready to begin.
    For some beginner tips on playing, try the Hints Button --- the "life-ring" to the left of this box.
    ScriptBox START 23 259 115 50 Start
*/

function TitleRoom(game) {

    this.Room_constructor(game, 'title');

    this.busAnimParams = [
        {dest: {x: 375, y: 214}, duration: 4000, next: 'west'},
        {dest: {x: 375, y: 214}, duration: 2500, next: 'west'},

        {dest: {x: 335, y: 204}, duration: 1000, next: 'west'},
        {dest: {x: 314, y: 214}, duration: 500, next: 'turn_s'},
        {dest: {x: 300, y: 252}, duration: 800, next: 'south'},
        {dest: {x: 283, y: 263}, duration: 500, next: 'turn_w'},

        {dest: {x: 96, y: 212}, duration: 3500, next: 'west'},
        {dest: {x: 96, y: 212}, duration: 2500, next: 'west'},

        {dest: {x: -25, y: 180}, duration: 3100, next: 'west'},
        {dest: {x: -125, y: 180}, duration: 6500, next: 'west'}
    ];

    this.busPhase = 0;
}

createjs.extend(TitleRoom, Room);

TitleRoom.prototype.preload =
    function () {
        this.manifest =
            this.makeManifest(this.id, [
                '#scene', 'bus-frames', 'credits', 'julius', 'title',
                {full_id: 'theme', full_src: 'anywhere.mp3'}
            ]);

        this.Room_preload(this.manifest);
    };

TitleRoom.prototype.load =
    function () {
        this.Room_load();

        /* The theme song */
        this.theme = this.world.queue.getResult('theme');

        /* Animation: The bus */
        this.loadBus();

        /* The game title banner -- "ANYWHERE MACHINE" */
        this.loadTitle();

        /* The game kicker - "Uncle Julius and the" */
        this.loadKicker();

        /* The credits */
        this.loadCredits();

        /* See-through rectangle over button */
        this.loadButtonArea();

        return this;
    };

TitleRoom.prototype.enter =
    function () {
        this.Room_enter(
            'Welcome to “Uncle Julius and the Anywhere Machine”! ' +
            'Click or tap “BEGIN THE ADVENTURE” when you’re ready to play. ' +
            'For some beginner tips on playing, try the Hints Button — the “life-ring” not at the left of this box.'
        );

        this.areaPlayButtonClickListener = this.areaPlayButton.on('click', this.leave, this);

        this.themeSong = createjs.Sound.play('theme');
        this.themeSong.volume = 0.1;
        this.themeSong.loop = -1;

        this.launchBusTween();
        this.launchTitleTween();

        return this;
    };

TitleRoom.prototype.leave =
    function () {
        this.areaPlayButton.off(this.areaPlayButtonClickListener);
        this.themeSong.stop();
        this.animBus.stop();

        this.Room_leave();
    };

TitleRoom.prototype.next =
    function () {
        return new BusRideRoom(this.world);
    };

TitleRoom.prototype.nextTitlePhase =
    function () {
        this.launchTitleTween();
        this.titlePhase = (this.titlePhase + 1) % 9;
    };

TitleRoom.prototype.launchTitleTween =
    function () {
        function tween (ob, props, time, noChain) {
            if (noChain)
                createjs.Tween.get(ob)
                    .to(props, time);
            else
                createjs.Tween.get(ob)
                    .to(props, time)
                    .call(this.nextTitlePhase, {}, this);
        }

        function wait(time) {
            tween(this.artTitle, {}, time);
        }

        switch (this.titlePhase) {
            case 0:
                // Wait 1500
                createjs.Tween.get(this.artTitle).to({}, 1500).call(this.nextTitlePhase, {}, this);
                break;
            case 1:
                // Fade in title over 3000
                createjs.Tween.get(this.artTitle).to({alpha: 1 }, 3000).call(this.nextTitlePhase, {}, this);
                break;
            case 2:
                // Hold 1500
                createjs.Tween.get(this.artTitle).to({ }, 1500).call(this.nextTitlePhase, {}, this);
                break;
            case 3:
                // Slide and fade in kicker over 1500
                ujPut(this.artJulius, -200 + Math.random() * 912, -65, 'kicker'); // -63
                createjs.Tween.get(this.artJulius).to({x: 137, y: 45, alpha: 1 }, 1500).call(this.nextTitlePhase, {}, this);
                break;
            case 4:
                // Hold 3000
                createjs.Tween.get(this.artJulius).to({}, 3000).call(this.nextTitlePhase, {}, this);
                break;
            case 5:
                // Fade in title over 1000 and kicker over 500 (then go to 6)
                createjs.Tween.get(this.artTitle).to({alpha: 0}, 1000);
                createjs.Tween.get(this.artJulius).to({alpha: 0}, 500).call(this.nextTitlePhase, {}, this);
                break;
            case 6:
                // Fade in credits over 1500
                createjs.Tween.get(this.artCredits).to({alpha: 1}, 1500).call(this.nextTitlePhase, {}, this);
                break;
            case 7:
                // Hold 3000
                createjs.Tween.get(this.artCredits).to({}, 3000).call(this.nextTitlePhase, {}, this);
                break;
            case 8:
                // Fade out credits over 1000
                createjs.Tween.get(this.artCredits).to({alpha: 0}, 1000).call(this.nextTitlePhase, {}, this);
                break;
        }
    };

TitleRoom.prototype.nextBusAnimStage =
    function () {
        this.busAnimStep = (this.busAnimStep + 1) % this.busAnimParams.length;
        this.launchBusTween();
    };

TitleRoom.prototype.launchBusTween =
    function () {

        if (this.busAnimStep == 0) {
            ujPut(this.animBus, 524, 253, 'bus-animation');
        }

        var ap = this.busAnimParams[this.busAnimStep];

        createjs.Tween.get(this.animBus).to(ap.dest, ap.duration * 2).call(this.nextBusAnimStage, {}, this);
        this.animBus.gotoAndPlay(ap.next);
    };

TitleRoom.prototype.loadBus =
    function () {
        var busAnimData = {
            images: [this.world.queue.getResult('title-bus-frames')],
            frames: {width: 25, height: 25, count: 5, regX: 12, regY: 12},
            animations: {
                west: 0,
                turn_s: {frames: [1, 2, 3], next: 'south', speed: 0.14},
                south: 4,
                turn_w: {frames: [3, 2, 1], next: 'west', speed: 0.15}
            }
        };

        this.artBusFrames = new createjs.SpriteSheet(busAnimData);
        this.animBus = new createjs.Sprite(this.artBusFrames, 'west');

        this.busAnimStep = 0;
        this.animBus.x = OFFSTAGE;

        this.reg(this.animBus);
    };

TitleRoom.prototype.loadButtonArea =
    function () {
        this.areaPlayButton = this.makeHitRect(23, 259, 115, 50, 'play', 'action');
        this.reg(this.areaPlayButton);
    };

TitleRoom.prototype.loadCredits =
    function () {
        this.artCredits = new createjs.Bitmap(this.world.queue.getResult('title-credits'));
        ujPut(this.artCredits, 96, 76, 'credits');
        this.artCredits.alpha = 0;
        this.reg(this.artCredits);
    };

TitleRoom.prototype.loadKicker =
    function () {
        this.artJulius = new createjs.Bitmap(this.world.queue.getResult('title-julius'));
        this.artJulius.alpha = 0;
        this.artJulius.name = 'kicker';
        this.reg(this.artJulius);
    };

TitleRoom.prototype.loadTitle =
    function () {
        this.artTitle = new createjs.Bitmap(this.world.queue.getResult('title-title'));
        ujPut(this.artTitle, 48, 100, 'title');
        this.artTitle.alpha = 0;
        this.titlePhase = 0;
        this.reg(this.artTitle);
    };

createjs.promote(TitleRoom, 'Room');
